
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/opinions",
      function () {
        return require("private-next-pages/opinions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/opinions"])
      });
    }
  